export default "__VITE_ASSET__DZ8gO7Kn__"